import { FieldErrors } from 'react-hook-form';

export type FlatFormError = {
  path: string;
  message: string;
};

export function flattenFormErrors(
  errors: FieldErrors,
  parentPath = ''
): FlatFormError[] {
  const result: FlatFormError[] = [];

  for (const key in errors) {
    const error: any = errors[key];
    const path = parentPath ? `${parentPath}.${key}` : key;

    if (!error) continue;

    if (error.message) {
      result.push({
        path,
        message: error.message,
      });
    }

    if (typeof error === 'object' && !error.message) {
      result.push(...flattenFormErrors(error, path));
    }
  }

  return result;
}
